// Disable Unlimited Bundle app auto-redirect on this page
window.bundleRedirectDisabled = true;
window.noAutoCartRedirect = true;

// Optional: Try to stop common bundle app redirects
document.addEventListener('cart:added', function(e) {
  e.stopImmediatePropagation();
}, true);

function initMachineWizard() {
  const machines = {
    airsense11: {
      name: "ResMed AirSense 11",
      image: "https://cdn.shopify.com/s/files/1/2016/4543/files/resmed-airsense-11-filter-12pk-hypoallergenic-resmed-900596.png?v=1717074599",

      steps: [

        {
          title: "Tube",
          image: "https://cdn.shopify.com/s/files/1/2016/4543/files/resmed-airsense-11-climateline-heated-tube-resmed-700360.png?v=1748569175",
          price: 75,
          handle: "resmed-climateline-air-11-heated-tube",
          variantId: 44376790565090,
          description: "The ResMed ClimateLineAir™ 11 CPAP tubing comes with a built-in sensor to monitor temperature levels. "
        },

        {
          title: "Chamber",
          image: "https://cpap.com.au/cdn/shop/files/resmed-humidair-10-standard-tub-resmed-638107.jpg?v=1717073979",
          price: 95,
          handle: "resmed-humidair-11-standard-tub",
          variantId: 44532929429730,
          description: "The HumidAir 11 Standard Water Tub is part of ResMed's Climate Control solution for the AirSense 11 series of devices."
        },

        {
          title: "Filters",
          image: "https://cdn.shopify.com/s/files/1/2016/4543/files/resmed-airsense-11-filter-12pk-resmed-902649.png?v=1717074270",
          price: 24,
          handle: "resmed-airsense-11-filter-12pk",
          variantId: 44376791679202,
          description: "Replacement air inlet filters for ResMed AirSense 11 devices."
        },

        {
          title: "Add Wipes",
          autoAdvance: false,           // ← Add this line
          note: "You can add one or both items to your bundle",   // ← Add this
          products: [

            {
              title: "Wipes 70 Tub",
              image: "https://cpap.com.au/cdn/shop/files/cpap-mask-wipes-70-tub-smartmed-9961069.png?v=1756849937",
              price: 15,
              handle: "cpap-mask-wipes-70-tub",
              variantId: 46797856800994,
              description: "Daily CPAP mask cleaning wipes."
            },

            {
              title: "Travel Pack (10)",
              image: "https://cpap.com.au/cdn/shop/files/cpap-mask-wipes-travel-pack-10-smartmed-4568975.png?v=1756932744",
              price: 10,
              handle: "cpap-mask-wipes-travel-pack-10",
              variantId: 46797856768226,
              description: "Compact travel wipe pack for CPAP cleaning."
            }

          ]
        },

        {
          title: "Descaler",
          image: "https://cpap.com.au/cdn/shop/files/eco-descaler-chamber-cleaner-500ml-smartmed-847207.jpg?v=1717075429",
          price: 30,
          handle: "eco-descaler-chamber-cleaner",
          variantId: 43089261527266,
          description: "Eco-friendly descaler and chamber cleaner designed to remove buildup and extend equipment life."
        }

      ]
    },

    airsense10: {
      name: "ResMed AirSense 10",
      image: "https://cpap.com.au/cdn/shop/files/resmed-airsense-10-autoset-device-with-4g-resmed-798719.jpg?v=1717074245",

      steps: [

        {
          title: "Tube",
          image: "https://cpap.com.au/cdn/shop/files/airsense-10-climateline-air-heated-tube-resmed-916448.jpg?v=1717075095",
          price: 65,
          handle: "climateline-air-heated-tube",
          variantId: 12224907444317,
          description: "ClimateLine Air Heated Tube designed to maintain consistent temperature and reduce rainout during therapy."
        },

        {
          title: "Chamber",
          image: "https://cpap.com.au/cdn/shop/files/resmed-humidair-10-standard-tub-resmed-638107.jpg?v=1717073979",
          price: 80,
          handle: "resmed-humidair-standard-tub",
          variantId: 42696999633122,
          description: "Replacement HumidAir chamber for maintaining optimal humidification and nightly comfort."
        },

        {
          title: "Filters",
          image: "https://cpap.com.au/cdn/shop/files/resmed-s9-airsense-10-filters-12pk-resmed-855895.jpg?v=1717074239",
          price: 25,
          handle: "resmed-s9-airsense-10-filters-12pk",
          variantId: 43003045773538,
          description: "12 pack of replacement filters to help keep dust and airborne particles out of your CPAP machine."
        },

        {
          title: "Add Wipes",
          autoAdvance: false,           // ← Add this line
          note: "You can add one or both items to your bundle",   // ← Add this
          products: [

            {
              title: "Wipes 70 Tub",
              image: "https://cpap.com.au/cdn/shop/files/cpap-mask-wipes-70-tub-smartmed-9961069.png?v=1756849937",
              price: 15,
              handle: "cpap-mask-wipes-70-tub",
              variantId: 46797856800994,
              description: "Daily CPAP mask cleaning wipes."
            },

            {
              title: "Travel Pack (10)",
              image: "https://cpap.com.au/cdn/shop/files/cpap-mask-wipes-travel-pack-10-smartmed-4568975.png?v=1756932744",
              price: 10,
              handle: "cpap-mask-wipes-travel-pack-10",
              variantId: 46797856768226,
              description: "Compact travel wipe pack for CPAP cleaning."
            }

          ]
        },

        {
          title: "Descaler",
          image: "https://cpap.com.au/cdn/shop/files/eco-descaler-chamber-cleaner-500ml-smartmed-847207.jpg?v=1717075429",
          price: 30,
          handle: "eco-descaler-chamber-cleaner",
          variantId: 43089261527266,
          description: "Eco-friendly descaler and chamber cleaner designed to remove buildup and extend equipment life."
        }

      ]
    },

    iDisc: {
      name: "SmartMed iDisc",
      image: "https://cdn.shopify.com/s/files/1/2016/4543/files/smartmed-idisc-hybrid-auto-with-humidifier-4g-smartmed-471066.jpg?v=1717075294",

      steps: [

        {
          title: "Tube",
          image: "https://cpap.com.au/cdn/shop/files/smartmed-ibreeze-idisc-heated-tube-smartmed-903342.jpg?v=1717075628",
          price: 80,
          handle: "smartmed-ibreeze-idisc-heated-tube",
          variantId: 35888740925599,
          description: "ClimateLine Air Heated Tube designed to maintain consistent temperature and reduce rainout during therapy."
        },

        {
          title: "Chamber",
          image: "https://cpap.com.au/cdn/shop/files/smartmed-idisc-water-chamber-smartmed-997078.jpg",
          price: 89,
          handle: "smartmed-idisc-water-chamber",
          variantId: 42747283407074,
          description: "Replacement HumidAir chamber for maintaining optimal humidification and nightly comfort."
        },

        {
          title: "Filters",
          image: "https://cdn.shopify.com/s/files/1/2016/4543/files/smartmed-idisc-filter-6pk-smartmed-167434.jpg?v=1717075851",
          price: 20,
          handle: "smartmed-idisc-filter-6pk",
          variantId: 32249578225757,
          description: "6 pack of replacement filters to help keep dust and airborne particles out of your CPAP machine."
        },

        {
          title: "Add Wipes",
          autoAdvance: false,           // ← Add this line
          note: "You can add one or both items to your bundle",   // ← Add this
          products: [

            {
              title: "Wipes 70 Tub",
              image: "https://cpap.com.au/cdn/shop/files/cpap-mask-wipes-70-tub-smartmed-9961069.png?v=1756849937",
              price: 15,
              handle: "cpap-mask-wipes-70-tub",
              variantId: 46797856800994,
              description: "Daily CPAP mask cleaning wipes."
            },

            {
              title: "Travel Pack (10)",
              image: "https://cpap.com.au/cdn/shop/files/cpap-mask-wipes-travel-pack-10-smartmed-4568975.png?v=1756932744",
              price: 10,
              handle: "cpap-mask-wipes-travel-pack-10",
              variantId: 46797856768226,
              description: "Compact travel wipe pack for CPAP cleaning."
            }

          ]
        },

        {
          title: "Descaler",
          image: "https://cpap.com.au/cdn/shop/files/eco-descaler-chamber-cleaner-500ml-smartmed-847207.jpg",
          price: 30,
          handle: "eco-descaler-chamber-cleaner",
          variantId: 43089261527266,
          description: "Eco-friendly descaler and chamber cleaner designed to remove buildup and extend equipment life."
        }

      ]
    },

    AirMini: {
      name: "ResMed AirMini",
      image: "https://cdn.shopify.com/s/files/1/2016/4543/files/resmed-airmini-n20-freedom-kit-resmed-683826.jpg",

      steps: [

        {
          title: "Tube",
          autoAdvance: false,           // ← Add this line
          note: "You can add one or both items to your bundle",   // ← Add this
          products: [

            {
              title: "ResMed F20 AirMini Setup Pack + HumidX",
              image: "https://cdn.shopify.com/s/files/1/2016/4543/files/resmed-f20-airmini-setup-pack-humidx-resmed-383759.jpg?v=1717074998",
              price: 60,
              handle: "resmed-f20-airmini-setup-pack-humidx",
              variantId: 42977884012770,
              description: "AirFit F20 SetUp Pack for AirMini Travel Device."
            },

            {
              title: "ResMed N20 AirMini Setup Pack",
              image: "https://cdn.shopify.com/s/files/1/2016/4543/files/resmed-n20-airmini-setup-pack-resmed-936271.jpg?v=1717074056",
              price: 75,
              handle: "airmini-n20-set-up-kit",
              variantId: 12113551720541,
              description: "AirFit N20 Set-Up Kit for AirMini Travel Device."
            },

            {
              title: "ResMed AirMini Tubing",
              image: "https://cdn.shopify.com/s/files/1/2016/4543/files/resmed-airmini-tubing-resmed-991564.jpg?v=1717074964",
              price: 25,
              handle: "resmed-airmini-tubing",
              variantId: 19526502449245,
              description: "Replacement tubing for the ResMed AirMini Travel Device."
            }

          ]
        },

                {
          title: "Filters",
          autoAdvance: false,           // ← Add this line
          note: "You can add one or both items to your bundle",   // ← Add this
          products: [

            {
              title: "ResMed HumidX Standard for AirMini",
              dynamicVariants: true,
              image: "https://cdn.shopify.com/s/files/1/2016/4543/files/resmed-humidx-standard-for-airmini-resmed-314444.jpg?v=1717075947",
              price: 35,
              handle: "resmed-humidx-standard-for-airmini",
              variantId: 42151617859,
              description: "HumidX are humidifier filters that have a 30 Day lifespan and extract moisture out of the air. "
            },

            {
              title: "ResMed HumidX PLUS for AirMini",
              dynamicVariants: true,
              image: "https://cdn.shopify.com/s/files/1/2016/4543/files/resmed-humidx-plus-for-airmini-resmed-803257.jpg?v=1717075102",
              price: 35,
              handle: "resmed-humidx-plus-for-airmini",
              variantId: 42151610691,
              description: "HumidX Plus are humidifier filters that have a one month lifespan and extract moisture out of the air."
            }

          ]
        },


        {
          title: "Add Wipes",
          autoAdvance: false,           // ← Add this line
          note: "You can add one or both items to your bundle",   // ← Add this
          products: [

            {
              title: "Wipes 70 Tub",
              image: "https://cpap.com.au/cdn/shop/files/cpap-mask-wipes-70-tub-smartmed-9961069.png?v=1756849937",
              price: 15,
              handle: "cpap-mask-wipes-70-tub",
              variantId: 46797856800994,
              description: "Daily CPAP mask cleaning wipes."
            },

            {
              title: "Travel Pack (10)",
              image: "https://cpap.com.au/cdn/shop/files/cpap-mask-wipes-travel-pack-10-smartmed-4568975.png?v=1756932744",
              price: 2.95,
              handle: "cpap-mask-wipes-travel-pack-10",
              variantId: 46797856768226,
              description: "Compact travel wipe pack for CPAP cleaning."
            }

          ]
        },


      ]
    },

        iBreeze: {
      name: "SmartMed iBreeze",
      image: "https://cdn.shopify.com/s/files/1/2016/4543/files/smartmed-ibreeze-bipap-st-a-device-smartmed-122384.jpg?v=1718134944",

      steps: [

        {
          title: "Tube",

          products: [

            {
              title: "Standard Tube",
              image: "https://cpap.com.au/cdn/shop/files/resmed-universal-tube-resmed-352566_1728x.png?v=1717075115",
              price: 25,
              handle: "resmed-universal-tube",
              variantId: 42152171139,
              description: "Standard Tubing for the SmartMed iBreeze CPAP Machine"
            },

            {
              title: "Heated Tube",
              image: "https://cdn.shopify.com/s/files/1/2016/4543/files/smartmed-ibreeze-idisc-heated-tube-smartmed-903342.jpg?v=1717075628",
              price: 80,
              handle: "smartmed-ibreeze-idisc-heated-tube",
              variantId: 35888740925599,
              description: "Heated tube for the SmartMed iBreeze & iDisc Machines."
            }

          ]
        },

        {
          title: "Chamber",
          image: "https://cdn.shopify.com/s/files/1/2016/4543/files/smartmed-ibreeze-water-chamber-smartmed-308034.jpg?v=1717074959",
          price: 110,
          handle: "smartmed-ibreeze-water-chamber",
          variantId: 42168807882978,
          description: "Replacement water chamber for the SmartMed iBreeze Series Devices."
        },

        {
          title: "Filters",
          image: "https://cdn.shopify.com/s/files/1/2016/4543/files/smartmed-ibreeze-filters-6pk-smartmed-772925.jpg?v=1717076081",
          price: 15,
          handle: "smartmed-ibreeze-filters-3pk",
          variantId: 13560590303325,
          description: "Premium quality air inlet filters to suit SmartMed iBreeze CPAP Devices. Available in a 6pk."
        },

        {
          title: "Add Wipes",
          autoAdvance: false,           // ← Add this line
          note: "You can add one or both items to your bundle",   // ← Add this
          products: [

            {
              title: "Wipes 70 Tub",
              image: "https://cpap.com.au/cdn/shop/files/cpap-mask-wipes-70-tub-smartmed-9961069.png?v=1756849937",
              price: 15,
              handle: "cpap-mask-wipes-70-tub",
              variantId: 46797856800994,
              description: "Daily CPAP mask cleaning wipes."
            },

            {
              title: "Travel Pack (10)",
              image: "https://cpap.com.au/cdn/shop/files/cpap-mask-wipes-travel-pack-10-smartmed-4568975.png?v=1756932744",
              price: 10,
              handle: "cpap-mask-wipes-travel-pack-10",
              variantId: 46797856768226,
              description: "Compact travel wipe pack for CPAP cleaning."
            }

          ]
        },

        {
          title: "Descaler",
          image: "https://cpap.com.au/cdn/shop/files/eco-descaler-chamber-cleaner-500ml-smartmed-847207.jpg",
          price: 30,
          handle: "eco-descaler-chamber-cleaner",
          variantId: 43089261527266,
          description: "Eco-friendly descaler and chamber cleaner designed to remove buildup and extend equipment life."
        }

      ]
    },

 sleepstyle: {
      name: "Fisher & Paykel SleepStyle",
      image: "https://cdn.shopify.com/s/files/1/2016/4543/files/fp-sleepstyle-plus-auto-device-fisher-paykel-437786.jpg?v=1722526794",

      steps: [

        {
          title: "Tube",
          image: "https://cdn.shopify.com/s/files/1/2016/4543/files/fp-sleepstyle-thermosmart-airspiral-heated-tube-fisher-paykel-159651.jpg?v=1717074413",
          price: 95,
          handle: "f-p-sleepstyle-thermosmart-airspiral-heated-tube",
          variantId: 28347296088157,
          description: "Replacement tube for the F&amp;P SleepStyle CPAP Devices."
        },

        {
          title: "Chamber",
      autoAdvance: false,           // ← Add this line
      note: "You can add one or both items to your bundle",   // ← Add this
      products: [   
        {
          title: "Chamber", 
          image: "https://cdn.shopify.com/s/files/1/2016/4543/files/fp-sleepstyle-water-chamber-outer-seal-not-included-fisher-paykel-262013.jpg?v=1717074535",
          price: 120,
          handle: "fisher-paykel-sleepstyle-humidifier-chamber",
          variantId: 44376057475,
          description: "This new and improved chamber now opens up for easy use unlike the F&amp;P ICON series chamber."
        },
                    {
          title: "Chamber Seal",
          image: "https://cdn.shopify.com/s/files/1/2016/4543/files/fp-sleepstyle-chamber-seal-fisher-paykel-827632.jpg?v=1717075652",
          price: 39,
          handle: "fisher-and-paykel-healthcare-sleepstyle-chamber-seal",
          variantId: 32166301401181,
          description: "The F&P SleepStyle Chamber Seal effectively allows the machine to seal the pressure within the chamber and prevent leaking of pressure."
            }

          ]
          },

        {
          title: "Filters",
          image: "https://cdn.shopify.com/s/files/1/2016/4543/files/fp-sleepstyle-plus-air-filter-2pk-fisher-paykel-408975.jpg?v=1733437786",
          price: 20,
          handle: "fp-sleepstyle-plus-air-filter-2pack",
          variantId: 46174512152802,
          description: "Replacement Standard air inlet filters for the SleepStyle+ PLUS Series Machine."
        },

        {
          title: "Add Wipes",
          autoAdvance: false,           // ← Add this line
          note: "You can add one or both items to your bundle",   // ← Add this
          products: [

            {
              title: "Wipes 70 Tub",
              image: "https://cpap.com.au/cdn/shop/files/cpap-mask-wipes-70-tub-smartmed-9961069.png?v=1756849937",
              price: 15,
              handle: "cpap-mask-wipes-70-tub",
              variantId: 46797856800994,
              description: "Daily CPAP mask cleaning wipes."
            },

            {
              title: "Travel Pack (10)",
              image: "https://cpap.com.au/cdn/shop/files/cpap-mask-wipes-travel-pack-10-smartmed-4568975.png?v=1756932744",
              price: 10,
              handle: "cpap-mask-wipes-travel-pack-10",
              variantId: 46797856768226,
              description: "Compact travel wipe pack for CPAP cleaning."
            }

          ]
        },

        {
          title: "Descaler",
          image: "https://cpap.com.au/cdn/shop/files/eco-descaler-chamber-cleaner-500ml-smartmed-847207.jpg?v=1717075429",
          price: 30,
          handle: "eco-descaler-chamber-cleaner",
          variantId: 43089261527266,
          description: "Eco-friendly descaler and chamber cleaner designed to remove buildup and extend equipment life."
        }

      ]
    },


  };

  
  let currentMachineKey = null;
  let currentStepIndex = 0;
  let selections = {};

  const $ = (id) => document.getElementById(id);

  /* =====================================================
     TOAST
  ===================================================== */

  function showToast(text) {

    const toast = document.createElement('div');

    toast.className = 'cart-toast';
    toast.innerHTML = `✓ ${text}`;

    document.body.appendChild(toast);

    setTimeout(() => {
      toast.classList.add('show');
    }, 10);

    setTimeout(() => {

      toast.classList.remove('show');

      setTimeout(() => {
        toast.remove();
      }, 300);

    }, 2200);

  }


  /* =====================================================
     MACHINE CARDS
  ===================================================== */

  function renderMachineCards() {

    const grid = $('machines-grid');

    if (!grid) return;

    grid.innerHTML = '';

    Object.keys(machines).forEach(key => {

      const machine = machines[key];

      const card = document.createElement('div');

      card.className = 'machine-card';
      card.dataset.machine = key;

      if (!machine.steps.length) {

        card.classList.add('placeholder-machine');

        card.innerHTML = `
          <div class="placeholder-inner">
            <span>Coming Soon</span>
          </div>
        `;

      } else {

        card.innerHTML = `
          <img src="${machine.image}" alt="${machine.name}">
          <h3>${machine.name}</h3>
        `;

      }

      grid.appendChild(card);

    });

  }

  /* =====================================================
     STEP LABELS
  ===================================================== */

  function renderStepLabels(machine) {

    document.querySelector('.step-labels')?.remove();

    const labels = document.createElement('div');

    labels.className = 'step-labels';

    machine.steps.forEach((step, index) => {

      const label = document.createElement('div');

      label.className = 'step-label';

      if (index === 0) {
        label.classList.add('active');
      }

      label.textContent = step.title;

      labels.appendChild(label);

    });

    const summary = document.createElement('div');

    summary.className = 'step-label';
    summary.textContent = 'Summary';

    labels.appendChild(summary);

    document
      .querySelector('.wizard-progress-bar')
      ?.insertAdjacentElement('afterend', labels);

  }

/* =====================================================
   MULTI PRODUCT STEP
===================================================== */

function renderMultiProductStep(step) {

  let html = `<div class="multi-product-grid">`;

  // Note (full width)
if (step.note) {
    html += `
      <div class="step-note">
        <strong>💡 Note:</strong> ${step.note}
      </div>
    `;
  }
  step.products.forEach(product => {
    html += `

      <div class="multi-card">
        <img src="${product.image}" alt="${product.title}">
        <h3>${product.title}</h3>
        <p>${product.description}</p>
<strong class="live-price-multi" data-handle="${product.handle}">
  Loading...
</strong>

${product.dynamicVariants ? `
  <div class="variant-selector">
    <select
      class="variant-select"
      data-handle="${product.handle}"
    >
      <option>Loading options...</option>
    </select>
  </div>
` : ''}
        <div class="quantity-selector">
          <button class="qty-minus" type="button">-</button>
          <span class="qty-value">1</span>
          <button class="qty-plus" type="button">+</button>
        </div>
        <button
          class="add-to-cart-btn btn-primary"
          data-handle="${product.handle}"
          data-title="${product.title}"
          data-step-title="${step.title}"
          data-price="${product.price}"
          data-variant="${product.variantId}"
          type="button"
        >
          Add to Cart
        </button>
      </div>
    `;
  });

  html += `</div>`;
  return html;
}

/* =====================================================
   LOAD DYNAMIC VARIANTS
===================================================== */

function loadDynamicVariants() {

  const selects = document.querySelectorAll('.variant-select');

  selects.forEach(select => {

    const handle = select.dataset.handle;

    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {

        const priceEl = document.querySelector(
          `.live-price-multi[data-handle="${handle}"]`
        );

        select.innerHTML = '';

        product.variants.forEach((variant, index) => {

          const option = document.createElement('option');

          option.value = variant.id;

          option.dataset.price = variant.price / 100;

          option.textContent =
            `${variant.title} - $${(variant.price / 100).toFixed(2)} AUD`;

          select.appendChild(option);

          /* SET FIRST PRICE */

          if (index === 0 && priceEl) {

            priceEl.textContent =
              `$${(variant.price / 100).toFixed(2)} AUD`;

          }

        });

        /* LIVE PRICE CHANGE */

        select.addEventListener('change', () => {

          const selected =
            select.selectedOptions[0];

          const newPrice =
            parseFloat(selected.dataset.price);

          if (priceEl) {

            priceEl.textContent =
              `$${newPrice.toFixed(2)} AUD`;

          }

        });

      })

      .catch(err => {
        console.error('Variant load failed', err);
      });

  });

}

  /* =====================================================
     PROGRESS
  ===================================================== */

  function updateProgress(index, container) {

    currentStepIndex = index;

    const total = container.children.length;

    const progressFill = document.querySelector('.wizard-progress-fill');

    if (progressFill) {
      progressFill.style.width = ((index + 1) / total * 100) + '%';
    }

    document.querySelectorAll('.step-label').forEach((label, i) => {
      label.classList.toggle('active', i === index);
    });

    /* =====================================================
       GLOBAL NAV BUTTONS
    ===================================================== */

    const nextBtn = $('btn-next');
    const skipBtn = $('btn-skip');
    const finishBtn = $('btn-finish');

    if (index === total - 1) {

      updateSummary();

      if (nextBtn) nextBtn.style.display = 'none';

      if (skipBtn) skipBtn.style.display = 'none';

      if (finishBtn) {
        finishBtn.style.display = 'inline-flex';
      }

    } else {

      if (nextBtn) nextBtn.style.display = 'inline-flex';

      if (skipBtn) skipBtn.style.display = 'inline-flex';

      if (finishBtn) {
        finishBtn.style.display = 'none';
      }

    }

  }

  /* =====================================================
     SCROLL LISTENER
  ===================================================== */

  let scrollTimeout;

  function setupScrollListener(container) {

    container.addEventListener('scroll', () => {

      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }

      scrollTimeout = setTimeout(() => {

        const children = Array.from(container.children);

        const containerRect = container.getBoundingClientRect();

        let bestIndex = 0;
        let maxVisible = 0;

        children.forEach((child, i) => {

          const rect = child.getBoundingClientRect();

          const visible = Math.max(
            0,
            Math.min(rect.right, containerRect.right) -
            Math.max(rect.left, containerRect.left)
          );

          if (visible > maxVisible) {
            maxVisible = visible;
            bestIndex = i;
          }

        });

        updateProgress(bestIndex, container);

      }, 60);

    }, { passive: true });

  }

/* =====================================================
   SUMMARY + DISCOUNT LOGIC
===================================================== */

function updateSummary() {
  const el = $('summary-content');
  if (!el) return;

  let html = '';
  let subtotal = 0;
  let itemCountByStep = new Map();

  const machine = machines[currentMachineKey];
  if (!machine) return;

  const totalSteps = machine.steps.length;
  const isAirMini = currentMachineKey === 'AirMini';

  // Build summary
  Object.values(selections).forEach(item => {
    const lineTotal = item.qty * item.price;
    subtotal += lineTotal;

    const stepTitle = item.stepTitle || item.title;

    if (!itemCountByStep.has(stepTitle)) {
      itemCountByStep.set(stepTitle, 0);
    }
    itemCountByStep.set(stepTitle, itemCountByStep.get(stepTitle) + 1);

    html += `
      <div class="summary-item">
        <div>${item.title} × ${item.qty}</div>
        <div>$${lineTotal.toFixed(2)}</div>
      </div>
    `;
  });

  let discountAmount = 0;
  let finalTotal = subtotal;
  let discountTriggered = false;
  let message = '';

  // ==================== NEW DISCOUNT LOGIC ====================
  if (subtotal > 0) {

if (isAirMini) {

  /* Check for qualifying setup pack */

  const hasQualifyingSetupPack =
    Object.values(selections).some(item => {

      const title = item.title.toLowerCase();

      return (
        title.includes('n20 airmini setup pack') ||
        title.includes('f20 airmini setup pack')
      );

    });

  /* Trigger discount immediately */

  discountTriggered = hasQualifyingSetupPack;

  message =
    "Add an AirMini Setup Pack to unlock 5% off your bundle";

}
    else {
      // All other machines: Tube + Chamber is enough
      const hasTube = itemCountByStep.has('Tube') || Array.from(itemCountByStep.keys()).some(k => k.toLowerCase().includes('tube'));
      const hasChamber = itemCountByStep.has('Chamber') || Array.from(itemCountByStep.keys()).some(k => k.toLowerCase().includes('chamber'));

      discountTriggered = hasTube && hasChamber;
      message = "Add both Tube and Chamber for 5% off entire bundle";
    }

    if (discountTriggered) {
      discountAmount = subtotal * 0.05;
      finalTotal = subtotal - discountAmount;
    }
  }
  // ============================================================

  // === Discount Notice ===
  if (discountTriggered) {
    html += `
      <div class="discount-notice">
        🎉 <strong>5% Bundle Discount Applied!</strong><br>
        <small>You unlocked the discount</small>
      </div>

      <div class="summary-item discount-line" style="color:#137333; font-weight:600;">
        <div>Bundle Discount (5%)</div>
        <div>-$${discountAmount.toFixed(2)}</div>
      </div>
    `;
  } else {
    html += `
      <div class="discount-notice" style="background:#fff3cd; color:#856404; border-left-color:#ffc107;">
        <strong>${message}</strong><br>
        <small>Add more to unlock 5% off your entire order</small>
      </div>
    `;
  }

  html += `
    <div class="summary-total" style="margin-top:20px; font-size:1.1em; border-top:2px solid #ddd; padding-top:12px;">
      <strong>Total: $${finalTotal.toFixed(2)} AUD</strong>
    </div>
  `;

  if (discountAmount > 0) {
    html += `
      <div style="text-align:right; color:#666; font-size:0.95em;">
        (Original: $${subtotal.toFixed(2)})
      </div>
    `;
  }

  el.innerHTML = html || '<p>No products added yet.</p>';
}
  /* =====================================================
     STEP NAVIGATION
  ===================================================== */

  function goToStep(index) {

    const container = $('steps-container');

    if (!container) return;

    const maxIndex = container.children.length - 1;

    index = Math.max(0, Math.min(index, maxIndex));

    const target = container.children[index];

    if (target) {

      container.scrollTo({
        left: target.offsetLeft,
        behavior: 'smooth'
      });

    }

    updateProgress(index, container);

  }

  /* =====================================================
     RENDER STEPS
  ===================================================== */

  function renderSteps(machineKey) {

    currentMachineKey = machineKey;
    currentStepIndex = 0;
    selections = {};

    const machine = machines[machineKey];

    const container = $('steps-container');

    if (!container) return;

    container.innerHTML = '';

    renderStepLabels(machine);

    machine.steps.forEach((step) => {

      const div = document.createElement('div');

      /* MULTI PRODUCT STEP */

      if (step.products && step.products.length > 0) {

        div.className = 'step-content multi-step';

if (machineKey === 'AirMini' && step.title === 'Tube') {
  div.classList.add('airmini-tube');
}

        div.innerHTML = `

          <div class="step-right" style="width:100%">

            <h2>${step.title}</h2>

            ${renderMultiProductStep(step)}

          </div>

        `;

      }

      /* NORMAL STEP */

      else {

        div.className = 'step-content';

        div.innerHTML = `

          <div class="step-left">

            <img src="${step.image}" alt="${step.title}">

          </div>

          <div class="step-right">

            <h2>${step.title}</h2>

            <p>${step.description}</p>

            <p>

              <strong
                class="live-price"
                data-handle="${step.handle}"
              >
                Loading...
              </strong>

            </p>

            <div class="quantity-selector">

              <button class="qty-minus" type="button">-</button>

              <span class="qty-value">1</span>

              <button class="qty-plus" type="button">+</button>

            </div>

            <button
              class="add-to-cart-btn btn-primary"
              data-handle="${step.handle}"
              data-title="${step.title}"
              data-step-title="${step.title}"
              data-price="${step.price}"
              data-variant="${step.variantId}"
              type="button"
            >
              Add to Cart
            </button>

          </div>

        `;

      }

      container.appendChild(div);

    });

    /* =====================================================
       SUMMARY STEP
    ===================================================== */

    const summaryDiv = document.createElement('div');

    summaryDiv.className = 'step-content';

summaryDiv.innerHTML = `
  <div class="step-right" style="width:100%; margin:auto;">

    <h2 style="text-align:center;">
      Bundle Summary
    </h2>

    <div id="summary-content"></div>

    <button
      id="go-cart-btn"
      class="btn-primary"
      type="button"
      style="margin:30px auto 0 auto; display:flex;"
    >
      Proceed to Cart →
    </button>

  </div>
`;

    container.appendChild(summaryDiv);

    /* =====================================================
       LIVE PRICING
    ===================================================== */

    machine.steps.forEach(step => {

      if (step.products && step.products.length > 0) {

        step.products.forEach(product => {

          fetch(`/products/${product.handle}.js`)
            .then(res => res.json())
            .then(data => {

              const priceEl = document.querySelector(
                `.live-price-multi[data-handle="${product.handle}"]`
              );

              if (priceEl && data.variants?.[0]) {

                const livePrice = (
                  data.variants[0].price / 100
                ).toFixed(2);

                priceEl.textContent = `$${livePrice} AUD`;

              }

            })
            .catch(() => {});

        });

      }

      else {

        fetch(`/products/${step.handle}.js`)
          .then(res => res.json())
          .then(data => {

            const priceEl = document.querySelector(
              `.live-price[data-handle="${step.handle}"]`
            );

            if (priceEl && data.variants?.[0]) {

              const livePrice = (
                data.variants[0].price / 100
              ).toFixed(2);

              priceEl.textContent = `$${livePrice} AUD`;

            }

          })
          .catch(() => {});

      }

    });

    $('machine-select')?.classList.add('hidden');
    $('accessory-flow')?.classList.remove('hidden');

setupScrollListener(container);

loadDynamicVariants();

goToStep(0);
  }

/* =====================================================
   LIVE HEADER CART UPDATE
===================================================== */

function updateHeaderCart() {

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      /* CART COUNT */

      const bubbles = document.querySelectorAll(
        '.cart-count-bubble span[aria-hidden="true"]'
      );

      bubbles.forEach(el => {
        el.textContent = cart.item_count;
      });

      /* VISUALLY HIDDEN TEXT */

      const hiddenText = document.querySelectorAll(
        '.cart-count-bubble .visually-hidden'
      );

      hiddenText.forEach(el => {
        el.textContent = `${cart.item_count} items`;
      });

      /* CART TOTAL */

      const totalEls = document.querySelectorAll(
        '.header__cart-total__price'
      );

      totalEls.forEach(el => {

        el.textContent =
          `$${(cart.total_price / 100).toFixed(2)} AUD`;

      });

    })

    .catch(err => {
      console.error('Cart update failed', err);
    });

}

  /* =====================================================
     CLICK EVENTS
  ===================================================== */

  document.addEventListener('click', (e) => {

    const machineCard = e.target.closest('.machine-card');

    if (machineCard && machineCard.dataset.machine) {

      renderSteps(machineCard.dataset.machine);

      return;

    }

    /* QUANTITY + */

    if (e.target.classList.contains('qty-plus')) {

      const el = e.target.parentElement.querySelector('.qty-value');

      if (el) {
        el.textContent = parseInt(el.textContent) + 1;
      }

    }

    /* QUANTITY - */

    if (e.target.classList.contains('qty-minus')) {

      const el = e.target.parentElement.querySelector('.qty-value');

      if (el) {
        el.textContent = Math.max(
          1,
          parseInt(el.textContent) - 1
        );
      }

    }

/* ADD TO CART */

if (e.target.classList.contains('add-to-cart-btn')) {

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const btn = e.target;

  const qtyEl = btn.parentElement.querySelector('.qty-value');

  const qty = qtyEl
    ? parseInt(qtyEl.textContent)
    : 1;

  /* IMPORTANT */
let variantId = btn.dataset.variant;

const card = btn.closest('.multi-card');

const variantSelect =
  card?.querySelector('.variant-select');

if (variantSelect) {

  variantId = variantSelect.value;

}

  /* Prevent double clicks */

  btn.disabled = true;
  btn.textContent = 'Adding...';

  /* ADD TO SHOPIFY CART */

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: qty
    })
  })

  .then(res => {

    if (!res.ok) {

      return res.text().then(text => {

        console.error('Shopify Error Response:', text);

        throw new Error('Cart add failed');

      });

    }

    return res.json();

  })

  .then(cartItem => {

/* GET LIVE PRODUCT PRICE */
return fetch(`/products/${btn.dataset.handle}.js`)
  .then(res => res.json())
  .then(data => {
    
    let livePrice = parseFloat(btn.dataset.price); // fallback

    if (data.variants && data.variants.length > 0) {
      // Use the actual current price from Shopify (most important line)
      livePrice = data.variants[0].price / 100;
      
      // Also update the button for consistency
      btn.dataset.price = livePrice;
    }

    if (variantSelect) {
      const selected = variantSelect.selectedOptions[0];
      if (selected && selected.dataset.price) {
        livePrice = parseFloat(selected.dataset.price);
      }
    }

    /* UNIQUE KEY */
    const selectionKey = btn.dataset.handle + '-' + (variantSelect ? variantSelect.value : btn.dataset.variant);

    if (selections[selectionKey]) {
      selections[selectionKey].qty += qty;
      selections[selectionKey].price = livePrice;   // update price too in case it changed
    } else {
      selections[selectionKey] = {
        qty: qty,
        title: btn.dataset.title,
        price: livePrice,                    // ← Now truly live
        stepTitle: btn.dataset.stepTitle || btn.dataset.title,
        handle: btn.dataset.handle,
        variantId: variantSelect ? variantSelect.value : btn.dataset.variant
      };
    }

    updateSummary();


/* =====================================================
   AUTO ADVANCE MULTI PRODUCT STEP
===================================================== */

const machine = machines[currentMachineKey];
const currentStep = machine?.steps[currentStepIndex];

if (currentStep?.products) {

  const allAdded = currentStep.products.every(product => {

    return Object.values(selections).some(item =>
      item.handle === product.handle &&
      item.qty > 0
    );

  });

  if (allAdded) {

    setTimeout(() => {
      goToStep(currentStepIndex + 1);
    }, 250);

  }

}

        /* TOAST */

        showToast(`${btn.dataset.title} added to cart`);

        /* BUTTON SUCCESS STATE */

        btn.classList.add('added');

        btn.innerHTML = 'Added ✓';

        /* LIVE HEADER CART UPDATE */

        updateHeaderCart();

        /* AUTO NEXT STEP */
setTimeout(() => {

  const container = $('steps-container');

  if (!container) return;

  const machine = machines[currentMachineKey];

  const currentStep = machine?.steps[currentStepIndex];

  if (!currentStep) return;

  /* SINGLE PRODUCT STEP */

  if (!currentStep.products) {

    const currentHandle = currentStep.handle;

    const wasAdded = Object.values(selections).some(item =>
      item.handle === currentHandle &&
      item.qty > 0
    );

    if (
      wasAdded &&
      currentStep.autoAdvance !== false
    ) {

      goToStep(currentStepIndex + 1);

    }

    return;

  }

  /* MULTI PRODUCT STEP */

  const handles = currentStep.products.map(
    p => p.handle
  );

  const allAdded = handles.every(handle => {

    return Object.values(selections).some(item =>
      item.handle === handle &&
      item.qty > 0
    );

  });

  if (allAdded) {

    goToStep(currentStepIndex + 1);

  }

}, 800);

      });

  })

  .catch(error => {

    console.error('Cart Error:', error);

    alert('Cart Error - check console');

    showToast('Failed to add item');

  })

.finally(() => {

  /* KEEP SUCCESS STATE */

  if (!btn.classList.contains('added')) {

    btn.disabled = false;
    btn.textContent = 'Add to Cart';

  }

});

}

    /* NEXT */

    if (e.target.id === 'btn-next') {
      goToStep(currentStepIndex + 1);
    }

    /* SKIP */

    if (e.target.id === 'btn-skip') {
      goToStep(currentStepIndex + 1);
    }

    /* BACK */

if (e.target.id === 'btn-back') {

  /* STEP 1 → RETURN TO MACHINE SELECT */

  if (currentStepIndex === 0) {

    $('machine-select')?.classList.remove('hidden');
    $('accessory-flow')?.classList.add('hidden');

    currentMachineKey = null;
    currentStepIndex = 0;
    selections = {};

    return;
  }

  /* NORMAL BACK */

  goToStep(currentStepIndex - 1);

}

    /* FINISH */

if (
  e.target.id === 'btn-finish' ||
  e.target.id === 'go-cart-btn'
) {

  window.location.href = '/cart';

}

  });

  /* =====================================================
     START
  ===================================================== */

  renderMachineCards();

}

/* =====================================================
   INIT
===================================================== */

if (document.readyState === 'loading') {

  document.addEventListener(
    'DOMContentLoaded',
    initMachineWizard
  );

} else {

  initMachineWizard();

}